import React from 'react';
import styled from 'styled-components';
import NewMenuItem from '../../../components/new-menu/new-menu-item';
import Flex from '../../../components/layout/flex';
import { labelProfileMenuSections } from '../label-sidebar';

interface LabelMenuOptionsProps {
  className?: string;
  dealsEnabled: boolean;
}

export const LabelMenuOptions: React.FC<LabelMenuOptionsProps> = ({
  className,
  dealsEnabled,
}) => {
  const options = React.useMemo(
    () => labelProfileMenuSections({ deals: dealsEnabled }),
    [dealsEnabled]
  );

  return (
    <Flex
      className={className}
      alignItems="flex-start"
      justifyContent="flex-start"
      gap={6}
      flexDirection="column"
      flexWrap="wrap"
    >
      {options.map((section, i) => (
        <NewMenuItem
          active={!section.disabled}
          to={section.path}
          soon={!!section.soon}
          key={i}
        >
          {section.label}
        </NewMenuItem>
      ))}
    </Flex>
  );
};

export default styled(LabelMenuOptions)`
  margin: 15px 0px;
`;
